// ./src/components/generic/form/pickerRules.ts
//
// The phone pickers' two decisions, PURE (no React, no Mantine) so `check-mobile-pickers` can RUN them.

// A phone picker over more options than this gets a search box even when the caller did not ask for one.
export const PICKER_SEARCH_THRESHOLD = 7;

/**
 * Does a select open the FULL-SCREEN picker? On every phone, whatever the list's length (owner, 2026-10-09: "on mobile
 * we use full screen selectors consistently") — only a control that cannot be used keeps its box. Never on a desktop.
 */
export const usesPhonePicker = (args: { isMobile: boolean | undefined; disabled?: boolean; readOnly?: boolean }): boolean =>
  !!args.isMobile && !args.disabled && !args.readOnly;

/**
 * Does the phone picker show a search box? When the caller asked (`searchable`), when the list is long, when typing
 * names a new option (create in place), or when the search is the caller's own (a server lookup). A short list of
 * fixed choices reads better without one.
 */
export const phonePickerSearchable = (args: { searchable?: boolean; optionCount: number; canCreate?: boolean; externalSearch?: boolean }): boolean =>
  !!args.searchable || args.optionCount > PICKER_SEARCH_THRESHOLD || !!args.canCreate || !!args.externalSearch;
